import CarHireCheapestProvider from './CarHireCheapestProvider';

export default CarHireCheapestProvider;
